import { useKeycloak } from "@react-keycloak/web";
import { Navigate } from "react-router-dom";

export default function PowerUserRoute({ children }) {
  const { keycloak } = useKeycloak();
  const isPowerUser = keycloak.realmAccess.roles.includes("poweruser");
  console.log("keycloak");
  console.log(keycloak.realmAccess.roles);
  console.log(isPowerUser);
//  .includes("banana")

  return isPowerUser ? children : <Navigate to="/" />;
}
